export const typefaceTester = () => {
    const btnColorSwitcher = ".js-color-switcher";
    // const typefaceTester = document.querySelector(".type-tester");
    var r = document.querySelector(":root");

  // false = dark mode because of the way I wrote the CSS
  const active = false;
  const setActive = false;

  let theme = localStorage.getItem("theme");

  if ($(".js-color-switcher")) {

    $(".js-color-switcher").on("click", function (e) {
      e.preventDefault();
      e.stopPropagation();

      var countItems = $(this).children().length;
      var current = $(this).children(".is-active");
      var shown = $(this).children(".is-shown-button");

      current.removeClass("is-active");
      shown.removeClass("is-shown-button");

      if (current.index() === countItems - 1) {
        $(this).find(".js-color-switcher-item:first").addClass("is-active");
        // $(this).find(".js-color-switcher-item:first").next().addClass("is-shown-button");
        var background = $(this).find(".js-color-switcher-item:first").attr("data-color-background");
        var text = $(this).find(".js-color-switcher-item:first").attr('data-color-text');
        changeColor(background, text);
      } else {
        current.next().addClass("is-active");
        // current.next().next().addClass("is-shown-button");
        var background = current.next().attr("data-color-background");
        var text = current.next().attr("data-color-text");
        changeColor(background, text);
      }

      if (shown.index() === countItems - 1) {
        $(this).find(".js-color-switcher-item:first").addClass("is-shown-button");
      } else {
        shown.next().addClass("is-shown-button");
      }

    });

    // btnColorSwitcher.onclick = function (e) {
    //   e.preventDefault();
    //   e.stopPropagation();

    //   var background = e.target.getAttribute("data-color-background");
    //   var text = e.target.getAttribute("data-color-text");
    //   changeColor(background, text);
    // };

  }

  const changeColor = (background, text) => {
    // document.body.classList.toggle("dark-mode");
    r.style.setProperty("--tt-color-background", background);
    r.style.setProperty("--tt-color-text", text);

  };

  const handleOnClick = () => {
    changeColor();
  };

};
